import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { CatalogueCreateComponent } from '../../../../core/components/catalogue-create/catalogue-create.component';
import { CatalogueImportComponent } from '../../../../core/components/catalogue-import/catalogue-import.component';
import { BxLogger } from '../../../../core/services/bx-logger.service';
import { CataloguesService } from '../../../../core/services/catalogues.service';
import { DialogService } from '../../../../core/services/dialog.service';
import { HelperService } from '../../../../core/services/helper.service';
import { PriceListService } from '../../../../core/services/price-list.service';
import { Catalogue } from '../../../../data/models/index';
import { GqlPaging, GqlSort, GqlSortDirection } from '../../../../shared/graphql/common';
import { LayoutService } from '../../../layout/layout.service';

interface TableConfig {
    sort: GqlSort;
    isDeleted: boolean;
    search: string;
    paging: GqlPaging;
}
@Component({
    selector: 'app-contact-catalogues',
    styleUrls: ['./contact-catalogues.component.scss'],
    templateUrl: './contact-catalogues.component.html',
    standalone: false,
})
export class ContactCataloguesComponent implements OnInit {
    // @ts-ignore TS7008
    @Input() contact;
    title = 'Contact Catalogues';
    priceLists: [] = [];

    // @ts-ignore TS2564
    cataloguesTranslation: string;

    /* required for ngx data table  */
    // @ts-ignore TS2564
    rows: Catalogue[];
    // @ts-ignore TS2564
    tableConfig: TableConfig;
    // @ts-ignore TS2564
    tableHeight: string;
    // @ts-ignore TS2564
    isLoading: boolean;

    @ViewChild('myTable') table: any;

    constructor(
        private helperService: HelperService,
        public layoutService: LayoutService,
        private priceListService: PriceListService,
        private cataloguesService: CataloguesService,
        private logger: BxLogger,
        private translateService: TranslateService,
        private dialogService: DialogService
    ) {
        this.translateService
            .get('catalogues.catalogue')
            .pipe(first())
            .subscribe((translation) => (this.cataloguesTranslation = translation));
    }

    ngOnInit() {
        this.resetPagingData();
        this.load();
    }

    resetPagingData() {
        this.tableConfig = {
            sort: { columnName: 'description', direction: 'ASC' },
            isDeleted: false,
            search: '',
            paging: {
                // @ts-ignore TS2322
                after: null,
                first: 50,
                // @ts-ignore TS2322
                last: null,
                totalCount: 0,
            },
        };
    }

    load() {
        this.isLoading = true;
        this.cataloguesService
            .getCatalogues(
                this.tableConfig.sort,
                this.tableConfig.paging,
                this.tableConfig.search,
                this.tableConfig.isDeleted,
                '',
                this.contact.ID_Contact
            )
            .then((result) => {
                if (result) {
                    this.rows = [...result.data.catalogues.nodes];
                }
                this.isLoading = false;
                // this.tableHeight = this.rows.length * 42 + 52 + 52 + 'px';
            });
    }

    exportToExcel(catalogue: Catalogue) {
        this.cataloguesService.exportCatalogueToExcelAndDownload(catalogue.iD_Catalogue, catalogue.name);
    }

    // @ts-ignore TS7006
    importFromExcel(priceList) {
        const initialState = {
            catalogue: priceList,
            hideOverwrite: false,
        };
        const modalRef = this.helperService.showModalAside(CatalogueImportComponent, { initialState });
        // @ts-ignore TS2532
        modalRef.content.action.pipe(first()).subscribe((result) => ({}));
    }

    addPriceList() {
        const modalRef = this.helperService.showModalAside(CatalogueCreateComponent);
        // @ts-ignore TS2532
        modalRef.content.action.pipe(first()).subscribe((result) => {
            if (!result.cancelled) {
                this.load();
                if (result.needImport) {
                    this.importFromExcel(result.catalogue);
                }
            }
        });
    }

    updateCatalogue(catalogue: Catalogue) {
        // map the new graphql price list to the old one
        const mappedCatalogue = this.mapCatalogueToLegacy(catalogue);
        this.priceListService
            .update(mappedCatalogue)
            // @ts-ignore TS7006
            .then((result) => {
                if (result) {
                    this.tableConfig.sort = {
                        columnName: 'dateModified',
                        direction: 'DESC' as GqlSortDirection,
                    };
                    this.load();
                }
            })
            .catch(() => ({}));
    }

    // @ts-ignore TS7006
    mapCatalogueToLegacy(catalogue) {
        return { ...catalogue, ...{ ID_PriceList: catalogue.iD_Catalogue, Description: catalogue.description, Name: catalogue.name } };
    }

    deleteCatalogue(catalogueId: string) {
        const params = {
            title: `Delete ${this.cataloguesTranslation}?`,
            text: `You can recover this ${this.cataloguesTranslation} by navigating to the main ${this.cataloguesTranslation} list, selecting \'Settings\', then \'Deleted Items\'.`,
        };

        this.dialogService.show(params).then(
            () => {
                this.cataloguesService
                    .deleteCatalogueById(catalogueId)
                    .then(() => {
                        this.logger.success(`${this.cataloguesTranslation} has been deleted`);
                        this.load();
                    })
                    .catch(() => {
                        this.logger.exception(`Error deleting ${this.cataloguesTranslation}`);
                    });
            },
            () => ({})
        );
    }

    // start ngx-datatable functions

    // @ts-ignore TS7006
    onSort(event) {
        this.tableConfig.sort = {
            columnName: event.sorts[0].prop,
            direction: (event.sorts[0].dir as string).toUpperCase() as GqlSortDirection,
        };
        this.load();
    }

    // end ngx-datatable functions
}
